const skills = [
    {
        id : 1,
        skill : "HTML",
        color : "#fcae5b"
    },
    {
        id : 2,
        skill : "CSS",
        color : "#5797ff"
    },
    {
        id : 3,
        skill : "Javascript",
        color : "#ffec73"
    },
    {
        id : 4 ,
        skill : "React",
        color :"#75bcff"
    },
    {
        id : 5,
        skill : "Nodejs:Express",
        color : "#85ff75"
    },
    {
        id : 6,
        skill : "Figma",
        color : "#ffbaf1"
    }
]

export default skills;